import React from 'react';
import { Link } from 'react-router-dom';   // ✅ Import Link for navigation
import AccessibilityBar from '../components/AccessibilityBar';
import './PageStyles.css'; // Shared layout styles
import './Tools.css'; // Tool-specific styles

const tools = [
  {
    name: 'Image Resizer',
    description: 'Resize images for exam uploads or profile photos.',
    icon: '🖼️',
    route: '/tools/image-resizer',
    active: true   // ✅ Mark this tool as active
  },
  {
    name: 'PDF Merger',
    description: 'Merge multiple PDFs into one for document submission.',
    icon: '📎',
    route: '/tools/pdf-merger',
    active: false
  },
  /*{
    name: 'Text Formatter',
    description: 'Clean and format text for resume or application.',
    icon: '📝',
    route: '/tools/text-formatter',
    active: false
  },
  {
    name: 'Link Shortener',
    description: 'Shorten long URLs for easy sharing.',
    icon: '🔗',
    route: '/tools/link-shortener',
    active: false
  }*/
];

const Tools = () => {
  return (
    <>
      <AccessibilityBar />
      <div className="container">
        <h1>🧰 Student Tools</h1>
        <p style={{ textAlign: 'center', marginBottom: '1rem' }}>
          These tools are designed to help students prepare and submit applications more efficiently.
        </p>

        <div className="tool-grid">
          {tools.map(tool => (
            <div key={tool.name} className="tool-card">
              <div className="tool-icon">{tool.icon}</div>
              <h3>{tool.name}</h3>
              <p>{tool.description}</p>
              {tool.active ? (
                // ✅ Active tool: show link
                <Link to={tool.route} className="tool-button">
                  Open Tool
                </Link>
              ) : (
                // ❌ Inactive tools: show "Coming Soon"
                <button className="tool-button" disabled>
                  Coming Soon
                </button>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Tools;
